import movieApi from "../api/movieApi";
import { isEqual, clone } from "lodash"
import debounceClass from "../utils/functions"
const _debounce = (new debounceClass()).debounce
const crowdMapping = {
  "overall": "总体",
  "male": "男",
  "female": "女",
  "below25": "<25",
  "above25": "≥25",
  "male_below25": "<25男",
  "male_above25": "≥25男",
  "female_below25": "<25女",
  "female_above25": "≥25女",
  "tier1": "一线城市",
  "tier2": "二线城市",
  "tier3": "三线城市",
  "below30": "<30",
  "above30": "≥30",
  "male_below30": "<30男",
  "male_above30": "≥30男",
  "female_below30": "<30女",
  "female_above30": "≥30女",
  "layer1": "18-24",
  "layer2": "25-29",
  "layer3": "30-34",
  "layer4": "≥35",
  "student": "学生",
  "non_student": "非学生",
  "parent": "家长",
  "non_parent": "非家长"
}
export default {
  data() {
    return {
      isLoading: false,
      crowdMapping: crowdMapping,
      movieApi: new movieApi(),
      //接口查询参数: query_ids ; query_crowd ; query_offset ;
      query_ids: [],
      query_crowds: [],

      //图表相关参数...
      //图表数据
      movieData: {},
      //折线图或者柱状图标示 1 : line ; 2: bar
      graphType: "line",
      //数据颜色设置
      colorMapping: {
        tag: {},
        movie: {}
      },
      //表格/图表设置项
      graphConfig: {},
    }
  },
  computed: {
    // query_offset: function () {
    //   return this.cycle.id === '' ? '' : this.cycle.id
    // },
    query_params: function () {
      return {
        offset: this.cycle.id === '' ? '' : this.cycle.id,
        query_ids: this.query_ids,
        query_crowds: this.query_crowds
      }
    },
    processedIndicator: function () {
      let tempIndex = this.indexId
      switch (tempIndex) {
        case 'expectation': {
          return this.toggleValue === 0 ? 'expectation' : 'expectation_p3'
        } break;
        // case 'primary_div' :{
        //   return this.toggleValue === 0 ? 'expectation' : 'expectation_p3'
        // } break;
        default: {
          return tempIndex
        }
      }
    }
  },
  methods: {
    changeLoadingStatus(status) {
      // if (status) {
      //   this.isLoading++
      // } else {
      //   this.isLoading--
      // }
      this.isLoading = status
    },
    getMovieSurveyData: _debounce(async function (params = { ids: this.query_params.query_ids, crowd: this.query_params.query_crowds, offset: this.query_params.offset, tag_ids: undefined, indicator: this.indexId }) {
      // let params = { ids: [], crowd: [], offset: "", tag_ids: [] }
      if (['primary_div', 'indicator'].includes(this.indexId)) {
        return
      }
      this.changeLoadingStatus(true)
      let res = undefined
      //处理取消请求
      try {
        res = await this.movieApi.getMovieListMarketInfo(params)
      } catch (error) {
        if (error.message = 'cancel') {
          //取消的接口
          // this.changeLoadingStatus(false)
          return
        } else {
          this.changeLoadingStatus(false)
          throw new Error("查询电影数据出错")
        }
      }
      //正常返回接口
      if (res.code !== 200 || res.status !== true) {
        this.changeLoadingStatus(false)
        throw new Error("查询电影数据出错")
      }
      //判断数据与上次数据是否深相同，是的话不重新计算并渲染
      if (isEqual(this.movieData, res.data)) {
        // return
      }
      //赋值数据
      this.movieData = clone(res.data)
      if (this.movieData.length === 0) {
        //没有数据，显示暂无数据
        this.hasNoData = true
        this.changeLoadingStatus(false)
        return
      } else {
        this.hasNoData = false
      }
      //判断是柱状图还是折线图
      this.judgeGraphType(this.movieData)
      //获取基础数据
      this.groupBy()
      //根据  表格/图表 和  柱状图/折线图 映前/映后 生成对应的数据格式
      this.generateExactlyFormatData()
      // this.changeLoadingStatus(false)
    }, 500),
    judgeGraphType(data) {
      //判断data的数据结构，判断该用柱状图还是折线图
      //只有当所有影片的数据都只有但周期，且均为同一单周期的时候才显示柱状图
      let last_offset = undefined
      for (let index = 0; index < data.length; index++) {
        let currentMovieResults = data[index].results
        // if (currentMovieResults.length > 1) {
        //   this.graphType = 'line'
        //   return
        // }
        for (let index2 = 0; index2 < currentMovieResults.length; index2++) {
          if (last_offset !== undefined && last_offset !== currentMovieResults[index2].offset) {
            this.graphType = 'line'
            return
          }
          last_offset = currentMovieResults[index2].offset
        }
      }
      this.graphType = 'bar'
    },
    generateExactlyFormatData() {
      // 1. 判断映前映后，对数据进行剪裁(映前: 映前四周--上映当周   映后: 映后一周，~两周)
      switch (this.beforeAfter) {
        case 'before': {
          this.graphConfig.labels = this.graphConfig.labels.slice(0, 5)
          this.graphConfig.datasets = this.graphConfig.datasets.map((dataset) => {
            dataset.data = dataset.data.slice(0, 5)
            return dataset
          })
        } break;
        case 'after': {
          this.graphConfig.labels = this.graphConfig.labels.slice(4)
          this.graphConfig.datasets = this.graphConfig.datasets.map((dataset) => {
            dataset.data = dataset.data.slice(4)
            return dataset
          })
        } break;
        default: { }
      }
      // 2. 根据周期选项进行处理（全周期正常显示， 单周期x轴只显示当前周期）
      if (this.cycle.id !== '' && this.graphConfig.labels && this.graphConfig.datasets) {
        //为单周期显示
        let currentSingleCycleIndex = undefined
        if (this.beforeAfter === 'before') {
          currentSingleCycleIndex = Number(this.cycle.id) + 4
        } else {
          currentSingleCycleIndex = Number(this.cycle.id)
        }
        this.graphConfig.labels = [this.graphConfig.labels[currentSingleCycleIndex]]
        this.graphConfig.datasets = this.graphConfig.datasets.map((dataset) => {
          dataset.data = [dataset.data[currentSingleCycleIndex]]
          return dataset
        })
      }
    },
    groupBy() {
      //初始化图像数据配置对象
      //折线图 x轴均为上映周期（映前4周到映后2周） 柱状图无x轴（只有一周数据时）
      this.graphConfig.type = this.graphType
      // this.graphConfig.labels = [{ id: "-4", label: "映前4周" }, { id: "-3", label: "映前3周" }, { id: "-2", label: "映前2周" }, { id: "-1", label: "映前1周" }, { id: "0", label: "上映当周" }, { id: "1", label: "映后1周" }, { id: "2", label: "映后2周" }]
      this.graphConfig.labels = [{ id: "-4", label: "映前4周" }, { id: "-3", label: "映前3周" }, { id: "-2", label: "映前2周" }, { id: "-1", label: "映前1周" }, { id: "0", label: "上映当周" }, { id: "1", label: "映后1周" }]
      this.graphConfig.datasets = []
      //根据当前筛选标签和电影，确定数据集分类原则，并进行分类
      //设置电影数和人群数的显示规则,0->没有  1->1有一个  n->n有多个  第一位为电影数目，第二位为人群数目
      //00  表示 0部电影 0个人群
      let movie_tag_flag = '' + (this.query_ids.length > 1 ? 'n' : this.query_ids.length) + (this.query_crowds.length > 1 ? 'n' : this.query_crowds.length === 1 && this.query_crowds[0] === 'overall' ? '0' : this.query_crowds.length)
      switch (movie_tag_flag) {
        //'0*'表示没有选择电影，默认没有数据
        case '00': { }; break;
        case '01': { }; break;
        case '0n': { }; break;
        //合理数据区
        case '10': {
          //一部影片无人群
          //如果是table模式，添加table需要的参数：电影上映时间 , 电影名  人群标签
          this.graphConfig.tableConfig = {
            launch: [],
            movie_title: [],
            crowd: [],
            base: []
          }
          this.graphConfig.tableConfig.launch.push(this.movieData[0].results[0].movie ? this.movieData[0].results[0].movie.launch : undefined)
          this.graphConfig.tableConfig.movie_title.push(this.movieData[0].results[0].movie_name || undefined)
          this.graphConfig.tableConfig.crowd.push('总体')
          let index = this.processedIndicator
          let data = [null, null, null, null, null, null]
          let movie_name = this.movieData[0].results[0].movie_name
          if (this.movieData[0] && this.movieData[0].results && this.movieData[0].results.length > 0) {
            this.movieData[0].results.forEach((item) => {
              data[Number(item.offset) + 4] = parseFloat(item[index] || 0)
              if (this.graphConfig.tableConfig.base[0] === undefined) {
                this.graphConfig.tableConfig.base[0] = item.base || '--'
              }
            })
            this.graphConfig.datasets = [{
              label: movie_name,
              borderWidth: '1',
              borderColor: this.colorMapping.tag[this.query_crowds[0]],            //线的外边框颜色
              backgroundColor: this.graphType === 'line' ? 'transparent' : this.colorMapping.tag[this.query_crowds[0]],     //背景色，常用transparent透明
              pointBorderColor: this.colorMapping.tag[this.query_crowds[0]],
              pointBackgroundColor: this.colorMapping.tag[this.query_crowds[0]],
              fill: true,
              data: data   //点的Y轴值
            }]
          }
          this.graphConfig = clone(this.graphConfig)
        }; break;
        case '11': {
          //一部影片一个人群， 按照电影分类
          //如果是table模式，添加table需要的参数：电影上映时间 , 电影名  人群标签
          this.graphConfig.tableConfig = {
            launch: [],
            movie_title: [],
            crowd: [],
            base: []
          }
          this.graphConfig.tableConfig.launch.push(this.movieData[0].results[0].movie ? this.movieData[0].results[0].movie.launch : undefined)
          this.graphConfig.tableConfig.movie_title.push(this.movieData[0].results[0].movie_name || undefined)
          this.graphConfig.tableConfig.crowd.push(this.crowdMapping[this.query_crowds[0]] || undefined)
          let index = this.processedIndicator
          let data = [null, null, null, null, null, null]
          let movie_name = this.movieData[0] ? this.movieData[0].results[0].movie_name : ""
          if (this.movieData && this.movieData[0] && this.movieData[0].results.length > 0) {
            this.movieData[0].results.map((item) => {
              data[Number(item.offset) + 4] = parseFloat(item[index] || 0)
              if (this.graphConfig.tableConfig.base[0] === undefined) {
                this.graphConfig.tableConfig.base[0] = item.base || '--'
              }
              // this.graphConfig.tableConfig.base[0][Number(item.offset) + 4] = parseFloat(item[`${index}_base`])
            })
          }
          this.graphConfig.datasets = [{
            label: movie_name,
            borderWidth: '1',
            borderColor: this.colorMapping.tag[this.query_crowds[0]],            //线的外边框颜色
            backgroundColor: this.graphType === 'line' ? 'transparent' : this.colorMapping.tag[this.query_crowds[0]],     //背景色，常用transparent透明
            pointBorderColor: this.colorMapping.tag[this.query_crowds[0]],
            pointBackgroundColor: this.colorMapping.tag[this.query_crowds[0]],
            fill: true,
            data: data      //点的Y轴值
          }]
          this.graphConfig = clone(this.graphConfig)
        }; break;
        case '1n': {
          //一部影片多个人群， 按照人群分类
          //如果是table模式，添加table需要的参数：电影上映时间 , 电影名  人群标签
          this.graphConfig.tableConfig = {
            launch: [],
            movie_title: [],
            crowd: [],
            base: []
          }
          let index = this.processedIndicator
          let data = []
          //每一个人群标签对应一个数据组
          let crowdGroups = {}
          let baseGroups = {}
          if (this.movieData[0] && this.movieData[0].results && this.movieData[0].results.length > 0) {
            this.movieData[0].results.forEach((item) => {
              if (crowdGroups[item.crowd]) {
                crowdGroups[item.crowd][Number(item.offset) + 4] = item[index]
              } else {
                crowdGroups[item.crowd] = []
                crowdGroups[item.crowd][Number(item.offset) + 4] = item[index]
              }
              baseGroups[item.crowd] = parseFloat(item.base)
            })
          }
          this.graphConfig.datasets =
            Object.entries(crowdGroups).map((item, row_index) => {
              if (!item[0]) {
                return
              }
              this.graphConfig.tableConfig.launch.push(this.movieData[0].results[0].movie ? this.movieData[0].results[0].movie.launch : undefined)
              this.graphConfig.tableConfig.movie_title.push(this.movieData[0].results[0].movie_name || undefined)
              this.graphConfig.tableConfig.crowd.push(this.crowdMapping[item[0]] || undefined)
              this.graphConfig.tableConfig.base[row_index] = baseGroups[item[0]]
              return {
                label: this.crowdMapping[item[0]],
                borderWidth: '1',
                borderColor: this.colorMapping.tag[item[0]],            //线的外边框颜色
                backgroundColor: this.graphType === 'line' ? 'transparent' : this.colorMapping.tag[item[0]],     //背景色，常用transparent透明
                pointBorderColor: this.colorMapping.tag[item[0]],
                pointBackgroundColor: this.colorMapping.tag[item[0]],
                fill: true,
                data: item[1]      //点的Y轴值
              }
            })
          let sortDatasets = []
          this.subCrowd.forEach(sort_item => {
            let temp = this.graphConfig.datasets.filter(unsort_item => {
              return unsort_item.label === this.crowdMapping[sort_item.id]
            })[0]
            if (temp) {
              sortDatasets.push(temp)
            }
          })
          this.graphConfig.datasets = clone(sortDatasets)
          this.graphConfig = clone(this.graphConfig)
        }; break;
        case 'n0': {
          //多部影片无人群，以电影分类（有多类）
          //如果是table模式，添加table需要的参数：电影上映时间 , 电影名  人群标签
          this.graphConfig.tableConfig = {
            launch: [],
            movie_title: [],
            crowd: [],
            base: []
          }
          let index = this.processedIndicator
          let data = []
          let base = []
          if (this.movieData && this.movieData.length > 0) {
            this.movieData.forEach((movie) => {
              data.push(movie.results)
            })
          }
          this.graphConfig.datasets = data.map((item, row_index) => {
            this.graphConfig.tableConfig.launch.push(item[0].movie ? item[0].movie.launch : undefined)
            this.graphConfig.tableConfig.movie_title.push(item[0].movie_name || undefined)
            this.graphConfig.tableConfig.crowd.push("总体")
            base[row_index] = '--'
            let tempData = [null, null, null, null, null, null]
            let movie_name = undefined
            base[row_index] = item[0].base
            item.forEach((item) => {
              movie_name = item.movie_name
              tempData[Number(item.offset) + 4] = item[index]
            })
            this.graphConfig.tableConfig.base = clone(base)
            return {
              label: movie_name,
              borderWidth: '1',
              borderColor: this.colorMapping.movie[item[0].movie_id],            //线的外边框颜色
              backgroundColor: this.graphType === 'line' ? 'transparent' : this.colorMapping.movie[item[0].movie_id],     //背景色，常用transparent透明
              pointBorderColor: this.colorMapping.movie[item[0].movie_id],
              pointBackgroundColor: this.colorMapping.movie[item[0].movie_id],
              fill: true,
              data: tempData  //点的Y轴值
            }
          })
          this.graphConfig = clone(this.graphConfig)
        }; break;
        case 'n1': {
          //多部影片一个人群，按照电影分类
          //如果是table模式，添加table需要的参数：电影上映时间 , 电影名  人群标签
          this.graphConfig.tableConfig = {
            launch: [],
            movie_title: [],
            crowd: [],
            base: []
          }
          let index = this.processedIndicator
          let data = []
          let base = []
          if (this.movieData && this.movieData.length > 0) {
            this.movieData.forEach((movie) => {
              data.push(movie.results)
            })
          }
          this.graphConfig.datasets = data.map((item, row_index) => {
            this.graphConfig.tableConfig.launch.push(item[0].movie ? item[0].movie.launch : undefined)
            this.graphConfig.tableConfig.movie_title.push(item[0].movie_name || undefined)
            this.graphConfig.tableConfig.crowd.push(this.crowdMapping[this.query_crowds[0]] || undefined)
            let tempData = [null, null, null, null, null, null]
            let movie_name = undefined
            base[row_index] = item[0].base
            item.forEach((item) => {
              movie_name = item.movie_name
              tempData[Number(item.offset) + 4] = parseFloat(item[index] || 0)
            })
            this.graphConfig.tableConfig.base = clone(base)
            return {
              label: movie_name,
              borderWidth: '1',
              borderColor: this.colorMapping.movie[item[0].movie_id],            //线的外边框颜色
              backgroundColor: this.graphType === 'line' ? 'transparent' : this.colorMapping.movie[item[0].movie_id],    //背景色，常用transparent透明
              pointBorderColor: this.colorMapping.movie[item[0].movie_id],
              pointBackgroundColor: this.colorMapping.movie[item[0].movie_id],
              fill: true,
              data: tempData
            }
          })
          this.graphConfig = clone(this.graphConfig)
        }; break;
        //'nn' 不存在
        case 'nn': { }; break;
        default: { };
      }
    },
    generateQueryList(activeMovieObj) {
      let all_movieslist_id = this.movieList.map(item => {
        return item.id
      })
      let mainId = this.$store.getters["movie/getMainMovieId"]
      if (activeMovieObj[mainId]) {
        all_movieslist_id = [mainId].concat(all_movieslist_id)
      }
      this.query_ids = all_movieslist_id.filter(item => activeMovieObj[item]).filter(item => {
        return item || item === 0
      })
    }
  },
  watch: {
    'currentActiveMovie': {
      handler: function (to, from) {
        this.generateQueryList(clone(to))

      },
      deep: true
    },
    'currentSubCrowd': {
      handler: function (to, from) {
        if (isEqual(to, from)) {
          return;
        }
        this.query_crowds = Object.entries(to)
          .filter((item) => { return item[1] === true })
          .map((item) => {
            return item[0]
          })
      },
      deep: true
    },
    query_params: {
      handler: function (to, from) {
        this.getMovieSurveyData({ ids: to.query_ids, crowd: to.query_crowds, offset: to.offset, tag_ids: undefined, indicator: this.indexId })
      },
      deep: true
    },
    // 'query_ids': {
    //   handler: async function (to, from) {
    //     //判断ids是否均相同，相同则不触发请求
    //     if (isEqual(to, from)) {
    //       return;
    //     }
    //     await (this.getMovieSurveyData())()
    //   },
    //   deep: true
    // },
    // 'query_crowds': async function (to, from) {
    //   if (isEqual(to, from)) {
    //     return;
    //   }
    //   await this.getMovieSurveyData()()
    // },
    // 'query_offset': async function (to, from) {
    //   if (isEqual(to, from)) {
    //     return;
    //   }
    //   await this.getMovieSurveyData()()
    // },
    processedIndicator: function (to, from) {
      this.groupBy()
      this.generateExactlyFormatData()
    }
  }
}